import apiService from '../http.service';
import { appConfig, BRAND } from '../../app.config';
import { languageList, countryList } from './../../app.values';
import Store from '@store';
import { setUserProfile } from '@reducers/actions';
import { mergeDeep } from '@services/helper.service';

class InitService {

  initDefault() {
    const settings = {
      CountryKey: -1,
      DesignStandard: '0',
      LanguageKey: '0',
      AvailableProfileTypes: 0,
      Brand: BRAND
    };

    // settings.LanguageKey = this.getBrowserLanguage();
    
    return this.manageRequest(settings, true);
  }

  initializeWith(settings) {
    return this.manageRequest(settings, false);
  }

  manageRequest(settings, initialize) {
    if (initialize && window.sessionStorage.getItem('clientId')) {
      apiService.get({ 
        query: `${appConfig.nonAuthPath.GET_OLD_PROFILE}?clientId=${window.sessionStorage.getItem('clientId')}` 
      })
      .then(oldProfile => {
        if (oldProfile) {
          settings.userProfile = mergeDeep(oldProfile, { needsUpdate: true });
          Store.dispatch(setUserProfile(oldProfile));
        }
        return this.initializeRequest(settings, initialize);
      });
    } else {
      return this.initializeRequest(settings, initialize);
    }
  }

  initializeRequest(settings, initialize) {
    return apiService.post({
      query: initialize ? appConfig.nonAuthPath.INIT : appConfig.path.UPDATE_SESSION,
      data: { settings }
    })
    .then(token => {
      // VladP: After refresh, sendRequest is called parameter initialize = true; 
      // so we're creating a new client but still using the previous clientId since it exists in the storage
      // for example, translations are loaded from the previous client language setting
      //if (window.sessionStorage.getItem('clientId') === null || window.sessionStorage.getItem('clientId') === undefined)
      if (initialize) 
        window.sessionStorage.setItem('clientId', JSON.stringify(token, null, 3));
      return token; // VladP: send the response further
    });
  }

  switchLanguage(langId) {
    return apiService.post({
      query: appConfig.path.SWITCH_LANGUAGE,
      data: { id: langId }
    });
  }

  getCountries() {
    return apiService.get({ query: appConfig.path.AVAILABLE_COUNTRIES });
  }

  getStandards(selectedCountry) {
    return apiService.get({ query: `${appConfig.nonAuthPath.DESIGN_STANDARDS}?country=${selectedCountry}` });
  }

  getProfiles(selectedCountry) {
    return apiService.get({ query: `${appConfig.nonAuthPath.COUNTRY_PROFILES}?country=${selectedCountry}` });
  }

  getLanguages(selectedCountry) {
    return apiService.get({ query: `${appConfig.nonAuthPath.AVAILABLE_LANGUAGES}?country=${selectedCountry}` });
  }

  getBrowserLanguage() {
    var lang = this.getSupportedLanguageKey(navigator.language);
    if (lang !== false) {
      return lang;
    } 
    else if (navigator.languages) { // check other available browser languages (might not be supported by the browser) 
      for (let i = 1; i < navigator.languages.length; i++) { // first item is always navigator.language
        lang = this.getSupportedLanguageKey(navigator.languages[i]);
        if (lang !== false) {
          return lang;
        }
      }
    }
  }

  getSupportedLanguageKey(lang) {
    if (null === lang || undefined === lang || '' === lang)
      return false;
    
    if (lang.indexOf("en") === 0) // Starts with en
    {
      if (lang === "en-US")
        return languageList['English US'];
      return languageList['English'];
    }
    if (lang.indexOf("de") === 0)
      return languageList['German'];
    if (lang.indexOf("nl") === 0)
      return languageList['Dutch'];
    if (lang.indexOf("fr") === 0)
    {
      if (lang === "fr-CA") // French-Canadian
        return languageList['French, Canadian'];
      return languageList['French'];
    }
    if (lang.indexOf("cs") === 0)
      return languageList['Czech'];
    if (lang.indexOf("es") === 0)
      return languageList['Spanish'];
    if (lang.indexOf("it") === 0)
      return languageList['Italian'];
    if (lang.indexOf("pl") === 0)
      return languageList['Polish'];
    if (lang.indexOf("ru") === 0)
      return languageList['Russian'];
    if (lang.indexOf("fi") === 0)
      return languageList['Finnish'];
    if (lang.indexOf("da") === 0)
      return languageList['Danish'];
    if (lang.indexOf("pt") === 0) {
      if (lang === "pt-BR") 
        return languageList['Portuguese, Brazil'];
      return languageList['Portuguese'];
    }
    if (lang.indexOf("tr") === 0)
      return languageList["Turkish"];
    
    return false;
  }

  getBrowserCountry() {
    // this.getCountries().then((countries) => {
      var country = this.getSupportedCountryKey(navigator.language);
      if (country !== false) {// && countries.find((c) => Number(c.InternalName) === country)) {
        return country;
      } 
      else if (navigator.languages) { // check other available browser languages (might not be supported by the browser)
        for (let i = 1; i < navigator.languages.length; i++) { // first item is always navigator.language
          country = this.getSupportedCountryKey(navigator.languages[i]);
          if (country !== false) { //} && countries.find((c) => Number(c.InternalName) === country)) {
            return country;
          }
        }
      }
    // });
  }

  getSupportedCountryKey(lang) {
    if (null === lang || undefined === lang || '' === lang)
      return false;

      if (lang.indexOf("AT") !== -1)
        return countryList['Austria'];
      if (lang.indexOf("BE") !== -1)
        return countryList['Belgium'];
      if (lang.indexOf("CZ") !== -1)
        return countryList['Czech Republic'];
      if (lang.indexOf("DE") !== -1)
        return countryList['Germany'];
      if (lang.indexOf("DK") !== -1)
        return countryList['Denmark'];
      if (lang.indexOf("ES") !== -1)
        return countryList['Spain'];
      if (lang.indexOf("FI") !== -1)
        return countryList['Finland'];
      if (lang.indexOf("FR") !== -1)
        return countryList['France'];
      if (lang.indexOf("GB") !== -1)
        return countryList['United Kingdom'];
      if (lang.indexOf("IT") !== -1)
        return countryList['Italy'];
      if (lang.indexOf("NL") !== -1)
        return countryList['Netherlands'];
      if (lang.indexOf("PL") !== -1)
        return countryList['Poland'];
      if (lang.indexOf("PT") !== -1)
        return countryList['Portugal'];
      // if (lang.indexOf("") !== -1)
      //   return countryList['Export'];
      if (lang.indexOf("BR") !== -1)
        return countryList['Brazil'];
      // if (lang.indexOf("") !== -1)
      //   return countryList['North America'];
      if (lang.indexOf("AU") !== -1)
        return countryList['Australia'];
      if (lang.indexOf("NZ") !== -1)
        return countryList['New Zealand'];
      // if (lang.indexOf("") !== -1)
      //   return countryList['Asia'];
      if (lang.indexOf("CA") !== -1)
        return countryList['Canada'];
      if (lang.indexOf("HK") !== -1)
        return countryList['Hong Kong'];
      // if (lang.indexOf("") !== -1)
      //   return countryList['Middle East'];
      // if (lang.indexOf("") !== -1)
      //   return countryList['China'];
      // if (lang.indexOf("") !== -1)
      //   return countryList['South East Asia'];

    return false;
  }

  getCurrentVersions() {
    return apiService.get({ query: appConfig.nonAuthPath.GET_CURRENT_VERSIONS });
  }
  
  getCountryInfo() {
    return apiService.get({ query: appConfig.path.GET_CURRENT_COUNTRY_INFO });
  }

}

export default new InitService();



// WEBPACK FOOTER //
// ./src/services/requests/init.service.js